import { render } from "./DynamicBanner.vue?vue&type=template&id=f195f504&scoped=true"
import script from "./DynamicBanner.vue?vue&type=script&lang=js"
export * from "./DynamicBanner.vue?vue&type=script&lang=js"

import "./DynamicBanner.vue?vue&type=style&index=0&id=f195f504&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f195f504"]])

export default __exports__